import React from 'react';
import ACEEditorContain from '../../Componant/Editor/AceCodeEditor/ACECodeEditor';

const ACEEditor = () => {
  return (
    <div className='page-body'>
      <ACEEditorContain />
    </div>
  );
};

export default ACEEditor;
